import { ProgressIndicator } from '@oneaudi/unified-web-components';
import { DATA_TEST_ID } from '~/test/data-test-id';
import { Tile } from '../style/image-selection-tile-style';

interface ImageSelectionTileProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
	isSelected: boolean;
	backgroundImage?: string;
	altText: string;
	isLoading: boolean;
	fallbackSVG: JSX.Element;
}

export const ImageSelectionTile = ({
	isSelected,
	backgroundImage,
	isLoading,
	altText,
	fallbackSVG,
	...buttonProps
}: ImageSelectionTileProps) => {
	return (
		<Tile
			data-testid={DATA_TEST_ID.SELECTION_TILE_BUTTON}
			isLoading={isLoading}
			isSelected={isSelected}
			{...buttonProps}>
			{backgroundImage ? <img loading="lazy" alt={altText} src={backgroundImage} /> : fallbackSVG}
			{isLoading && (
				<ProgressIndicator size={'lg'} className="progress-indicator" variant={'spinner'} type={'infinite'} />
			)}
		</Tile>
	);
};
